import { Group, Stack, TextInput, Title } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"

import { DigestResponses, DigestType } from "@costory/types/endpoints/digest"

import dayjs from "@costory/shared/dayjs"

export function DigestTitle({
  digestData,
  form,
  isDiff,
}: {
  digestData: DigestResponses.Investigation
  form: UseFormReturnType<DigestType>
  isDiff: boolean
}) {
  const date = dayjs(digestData[0].ffrom).format("MMMM YYYY")
  const prevDate = dayjs(digestData[0].previousTo).format("MMMM YYYY")
  return (
    <>
      <Stack>
        <TextInput
          {...form.getInputProps("name")}
          fw="bold"
          styles={{
            root: {
              paddingBottom: 0,
            },
            wrapper: {
              paddingBottom: 0,
            },
            input: {
              width: 500,
              maxWidth: 500,
              height: 44,
              fontSize: "var(--mantine-h1-font-size)",
              borderRadius: 0,
              paddingBottom: 4,
              border: "none",
            },
          }}
          variant="unstyled"
          placeholder="New Cost Digest"
          data-intercom-target="costory-tour-digest-name-input"
        />

        <Group>
          <Title order={5} c="textMuted">
            {`Comparing ${date} ${isDiff ? `vs ${prevDate}` : ""}`}
          </Title>
        </Group>
      </Stack>
    </>
  )
}
